import { atom } from 'recoil';

import {NET_BALANCE} from 'store/constants';

export const ANetBalance = atom<string>({
  key: NET_BALANCE,
  default: '0',
});
